import React from "react"
import styled from "styled-components"

const DottedLine = styled.div`
    height: 100%;
    width: 50px;
    background: url('/assets/gestaltungselemente/punkt-vertikal.svg');
    background-repeat: repeat-y;
    background-position: center;
    margin-bottom: 0 auto;
`

const DottedLineVertical = () => <DottedLine></DottedLine>

export default DottedLineVertical